import React , { useContext, useState } from "react";

import { DashboardBarElement, DashboardBarSelector, DashboardContent, DashboardHeader, DashboardSubtitle, DashboardTitle, InnerContainer, InnerContainerRow } from '../../../components/dashboard';

import { AuthenticationContext } from "../../../components/authentication";
import { PageLoading } from "../../../components/pageLoading";
import { useParams } from "react-router-dom";
import { Notice } from "../../../components/containers/notice";

import { useTicket } from "../../../hooks/tickets/useTicket";
import { useCurrentEvent } from "../../../hooks/events/useCurrentEvent";

import { TicketInformation } from "./ticketInformation";
import { PaymentInformation } from "./paymentInformation";
import { useBrand } from "../../../contexts/brand";
import { hasAnyBrandPermission } from "../../../utils/roles";

const TABS = {
    DETAILS: 1,
    PAYMENT: 2,
}

export const ViewTicket = () => {
    const { brandUuid } = useBrand();
    const { id } = useParams();

    const [activeContent, setActiveContent] = useState(TABS.DETAILS);

    // Import the following React contexts:
    const authContext = useContext(AuthenticationContext);

    const { data: ticket, isLoading: isLoadingTicket, error } = useTicket(id);
    const { data: currentEvent, isLoading: isLoadingCurrentEvent } = useCurrentEvent(brandUuid);

    const loading = isLoadingTicket || isLoadingCurrentEvent;
    const data = (ticket && currentEvent) ? { ticket, currentEvent } : null;

    if(loading) {
        return (<PageLoading />)
    } else if(hasAnyBrandPermission(authContext.roles, brandUuid, ["ticket_admin"])) {
        if(data) {
            return (
                <>
                    <DashboardHeader>
                        <DashboardTitle>
                            Billett
                        </DashboardTitle>
                        <DashboardSubtitle>
                            #{data.ticket.ticket_id} – {data.ticket.event.name}
                        </DashboardSubtitle>
                    </DashboardHeader>

                    <DashboardBarSelector border>
                        <DashboardBarElement active={activeContent === TABS.DETAILS} onClick={() => setActiveContent(TABS.DETAILS)}>Detaljer</DashboardBarElement>
                        <DashboardBarElement active={activeContent === TABS.PAYMENT} onClick={() => setActiveContent(TABS.PAYMENT)}>Betalingsinformasjon</DashboardBarElement>
                    </DashboardBarSelector>

                    <DashboardContent visible={activeContent === TABS.DETAILS}>
                        <TicketInformation data={data} />
                    </DashboardContent>

                    <DashboardContent visible={activeContent === TABS.PAYMENT}>
                        <PaymentInformation data={data} />
                    </DashboardContent>
                </>
            )
        } else {
            return (
                <>
                    <DashboardHeader border>
                        <DashboardTitle>
                            Billett
                        </DashboardTitle>
                    </DashboardHeader>

                    <DashboardContent>
                        <Notice type="error" visible>
                            Det oppsto en feil ved henting av informasjon for denne billetten.<br />
                            {error?.message}
                        </Notice>
                    </DashboardContent>
                </>
            )
        }
    } else {
        return (
            <>
                <DashboardContent>
                    <InnerContainer rowgap>
                        <InnerContainerRow>
                            <Notice type="error" visible>
                                Du har ikke tilgang til å se billettinformasjon.
                            </Notice>
                        </InnerContainerRow>
                    </InnerContainer>
                </DashboardContent>
            </>
            )
    }
}
